import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "editPropertyModal" }
const _hoisted_2 = { class: "editPropertyContent container p-6" }
const _hoisted_3 = { class: "formHolder" }
const _hoisted_4 = { class: "headline3 mb-5" }
const _hoisted_5 = { class: "sectionItem mb-4" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "sectionItem mb-4" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "sectionItem mb-4" }
const _hoisted_12 = { class: "label" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "sectionItem mb-4" }
const _hoisted_15 = { class: "label" }
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "sectionItem mb-4" }
const _hoisted_18 = { class: "label" }
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "sectionItem mb-4" }
const _hoisted_21 = { class: "label" }
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { class: "sectionItem mb-4" }
const _hoisted_24 = { class: "label" }
const _hoisted_25 = { class: "value" }
const _hoisted_26 = {
  key: 0,
  class: "geolocationItem mb-4"
}
const _hoisted_27 = { class: "label mb-4" }
const _hoisted_28 = { class: "value" }
const _hoisted_29 = { class: "buttonsHolder" }

import AButton from '@/components/Base/AButton.vue';
import AppInput from '@/components/v2/App/AppInput.vue';
import AppMap from '@/components/v2/App/AppMap.vue';
import { useStore } from "@/composables/useTypedStore";
import Immobilie from '@/models/immobilie.model';
import User from '@/models/user';
import { IonContent, modalController } from '@ionic/vue';
import { computed, ComputedRef, ref } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'EditPropertyModal',
  props: {
  property: {
    type: Object,
    required: true
  }
},
  setup(__props) {

const props = __props;



const store = useStore();
const { t } = useI18n({ useScope: 'global' })
const currentProject = computed(() => store.state.user.currentUserProject);
const isNetworkAvailable = computed(() => store.state.app.networkConnected)
const organisationPrefix: ComputedRef<string> = computed(() => {
  const currentUser: User | null = User.query().first();

  return currentUser ? currentUser.organisationPrefix : "";
});

const body = ref({
  name: props.property.name,
  strasse: props.property.strasse,
  plz: props.property.plz,
  stadt: props.property.stadt,
  stadtbezirk: props.property.stadtbezirk,
  externeObjektNr: props.property.externeObjektNr,
  baujahr: props.property.baujahr,
  geolocationLat: props.property.geolocationLat,
  geolocationLon: props.property.geolocationLon,
});

const isButtonActive = computed(() => {
  let value = false

  if(isNetworkAvailable.value) {
    value = buttonActiveOnline()
  } else {
    value = buttonActiveOffline()
  }

  return value
})

function buttonActiveOnline() {
  let value = false
  if(
    body.value.name &&
    body.value.baujahr &&
    body.value.geolocationLat &&
    body.value.geolocationLon
  ) {
    value = true
  } else {
    value = false
  }
  return value
}

function buttonActiveOffline() {
  let value = false
  if(
    body.value.name &&
    body.value.name
  ) {
    value = true
  } else {
    value = false
  }
  return value
}

const editProperty = async() => {
  const immobilieObject = {
    ...props.property,
    name: body.value.name,
    strasse: body.value.strasse,
    plz: body.value.plz,
    stadt: body.value.stadt,
    stadtbezirk: body.value.stadtbezirk,
    externeObjektNr: body.value.externeObjektNr,
    baujahr: body.value.baujahr,
    geolocationLat: body.value.geolocationLat,
    geolocationLon: body.value.geolocationLon
  } as Immobilie

  try {
    await Immobilie.api().put(`/immobilies/${props.property.id}?projectId=${currentProject.value.id}`, {
      save: true,
      data: immobilieObject
    })
  } catch(error: any) {
    immobilieObject.hasUnsavedChanges = true
  }

  await Immobilie.dispatch('storeMoverObject', immobilieObject );

  modalController.dismiss()
}

function onChanged(event: any) {
  if(event.features[0]?.geometry.coordinates) {
    body.value.geolocationLon = event.features[0].geometry.coordinates[0]
    body.value.geolocationLat = event.features[0].geometry.coordinates[1]
  }
}

function handleMapSearchResult(data: any) {
  body.value.strasse = data.address.road ? data.address.road : ''
  body.value.plz = data.address.postcode ? data.address.postcode : ''
  body.value.stadt = data.address.city ? data.address.city : ''
  body.value.stadtbezirk = data.address.city_district ? data.address.city_district : ''
  body.value.geolocationLat = data.lat
  body.value.geolocationLon = data.lon
}

function clearMapSearchResult() {
  body.value.strasse = ''
  body.value.plz = ''
  body.value.stadt = ''
  body.value.stadtbezirk = ''
  body.value.geolocationLat = ''
  body.value.geolocationLon
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)(`${organisationPrefix.value}createProperty.editObject`)), 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('createProperty.name')) + "* ", 1),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(AppInput, {
                  modelValue: body.value.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((body.value.name) = $event)),
                  placeholder: _unref(t)('createProperty.typeLabel')
                }, null, 8, ["modelValue", "placeholder"])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)(`${organisationPrefix.value}createProperty.externalObjNumber`)), 1),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(AppInput, {
                  modelValue: body.value.externeObjektNr,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((body.value.externeObjektNr) = $event)),
                  placeholder: _unref(t)('createProperty.typeLabel')
                }, null, 8, ["modelValue", "placeholder"])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)('createProperty.street')), 1),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(AppInput, {
                  modelValue: body.value.strasse,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((body.value.strasse) = $event)),
                  placeholder: _unref(t)('createProperty.typeLabel')
                }, null, 8, ["modelValue", "placeholder"])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)('createProperty.plz')), 1),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(AppInput, {
                  modelValue: body.value.plz,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((body.value.plz) = $event)),
                  placeholder: _unref(t)('createProperty.typeLabel')
                }, null, 8, ["modelValue", "placeholder"])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(t)('createProperty.city')), 1),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(AppInput, {
                  modelValue: body.value.stadt,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((body.value.stadt) = $event)),
                  placeholder: _unref(t)('createProperty.typeLabel')
                }, null, 8, ["modelValue", "placeholder"])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(t)('createProperty.bezirk')), 1),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(AppInput, {
                  modelValue: body.value.stadtbezirk,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((body.value.stadtbezirk) = $event)),
                  placeholder: _unref(t)('createProperty.typeLabel')
                }, null, 8, ["modelValue", "placeholder"])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(t)(`${organisationPrefix.value}createProperty.buildingYear`)) + "* ", 1),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(AppInput, {
                  modelValue: body.value.baujahr,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((body.value.baujahr) = $event)),
                  placeholder: _unref(t)('createProperty.typeLabel')
                }, null, 8, ["modelValue", "placeholder"])
              ])
            ]),
            (isNetworkAvailable.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(t)('createProperty.geoLocation')) + "* ", 1),
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(AppMap, {
                      identifier: 'objectLocation',
                      "map-settings": currentProject.value.mapConfig?.createPropertyMap,
                      "allow-only-one-drawing": true,
                      "property-location": {lat: __props.property.geolocationLat, lon: __props.property.geolocationLon},
                      "onUpdate:inputJson": onChanged,
                      "onUpdate:mapSearch": handleMapSearchResult,
                      "onUpdate:clearMapSearchInputs": clearMapSearchResult
                    }, null, 8, ["map-settings", "property-location"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(AButton, {
              disabled: isButtonActive.value ? false : true,
              "btn-primary": true,
              class: "px-16 py-6 text-lg",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (isButtonActive.value ? editProperty() : ''))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('editProperty.buttons.confirmEdit')), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(AButton, {
              "btn-secondary": true,
              class: "px-16 py-6 text-lg",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(modalController).dismiss()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('editProperty.buttons.cancelEdit')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})